module.exports = __webpack_public_path__ + "static/media/fuel.848e2185.svg";